import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const en = {
  posterPage: {
    title1:'Subscription Feature Coming Soon!',
    title2:'Renew Your Subscription - Unlock Enhanced Privileges!',
    title3:'Exclusive renewal discount - better value for members',
    title4:'To obtain your redemption code, please contact the authorized seller where you purchased the device.',
    title5:'Priority Experience Feature',
    function1:'Feature Details：',
    function2:'Core Service Renewal（Simultaneous Interpretation、Meeting Assistant、AI Assistant）.. ',
    function3:'Premium Add-Ons（Offline Translation、Call Translation）..',
  },
  RedemptionCodePage: {
    RedemptionCode: 'Redemption Code',
    ValueAddedServices: 'Value-added Services',
    UpgradedExperience: 'Exclusive value-added benefits, upgraded experience',
    OfflineTranslation: 'Offline translation',
    NoInternet: 'No Internet connection required · Instant translation · Safe and reliable',
    GoToSubscribe: 'Go to subscribe',
    AudioAndVideoCall: 'Audio/Video Call',
    RealTimeCall: 'Real-time voice translation, barrier-free communication',
    BaseService:'Basic Services',
    AIAssistant:'Function: Simultaneous interpretation, conference assistant, AI assistant',
    LanguagesSetting:'Language settings',
    languages1:'Simplified Chinese',
    languages2:'traditional Chinese',
    languages3:'English',
    languages4:'Japanese',
    languages5:'Korean',
    languages6:'Russian',
    languages7:'Spanish',
    languages8:'French',
    languages9:'German',
    languages10:'Portuguese',
    languages11:'Italian',
    languages12:'Turkish',
    languages13:'Vietnamese',
    languages14:'Indonesian',
    languages15:'Hindi',
    languages16:'Arabic',
    languages17:'Thai',
    languages18:'farsi',
  },
  Login:{
    ToLogin:'Log in',
    PhoneLogin:'Phone number login',
    EmailLogin:'Email Login',
    PhonePlaceholder:'Please enter',
    EmailPlaceholder:'Enter email',
    Code:'Verification Code', 
    and:'and',
    BeforeText:'By creating an account, you agree to and abide by the ',
    UserAgreement:'User Agreement',
    privacy:'Privacy Policy',
    errorMessage:'Verification code error',
    readTitle:'Read and agree to the following agreement',
    readBefore:'To ensure the security of your personal information, please read and agree first',
    cancel:'cancel',
    agree:'Agree and continue',
    error1:'Please enter a valid email address',
    error2:'Please enter the correct phone number',
    error3:'Please enter the verification code',
    success:'Login succeeded'
  },
  OffLinePage: {
    title:'Offline translation',
    NoInternet: 'No Internet connection required · Instant translation · Safe and reliable',
    ServiceLife:'Validity Period',
    forever:'Permanent use',
    describe:'Subscription Instructions',
    describeItem1:'1. The offline translation function is a one-time payment and can be used permanently. The usage rights follow the Bluetooth device. If you change the device, you need to re-subscribe to the offline translation redemption code. ',
    describeItem2:'2. The authorization code cannot be refunded after subscription.',
    describeItem3: '3. Supports 10 languages: Chinese, English, German, Japanese, Korean, Hindi, Thai, Spanish, French, Russian.',
    quantity:'quantity',
    payType:'Payment Methods',
    card:'Card',
    wx:'WeChat',
    GooglePay:'Google Pay',
    subscribe:'Subscription',
    RMB: '¥',
    confirm:'confirm',
    cardNumber:'Card number',
    periodOfValidity:'period of validity',
    safetyCode:'safety code',
    name:'full name',
    yearAndMonth:'year/month',
    message1:'The quantity cannot be 0',
    popTip:'Tips',
    popText1:'Please read and understand carefully',
    popText2:'Offline Translation Payment Agreement',
    popText3:'I have read and agree',
    popText4:'I have read and agree',
  },
  AudioVideoPage:{
    title:'Audio/Video Call',
    RealTime:'Real-time voice translation, barrier-free communication',
    describe:'Subscription Instructions',
    describeItem1:'1. The audio and video call translation function is a recharge to purchase minutes. The minutes are calculated from the time the call is connected. The permissions follow the account. If you log in to another account, you need to recharge again.',
    describeItem2:'2. After the account is recharged, it can be connected and bound to different devices as usual.',
    describeItem3:' 3. The audio and video call translation function cannot be refunded after recharging.',
    payType:'Payment Methods',
    card:'Card',
    wx:'WeChat',
    GooglePay:'Google Pay',
    subscribe:'Subscription',
    RMB: '¥',
    sale:'off',
    confirm:'confirm',
    time1:'second',
    time2:'minute',
    time3:'hour',
    time4:'day',
    time5:'the moon',
    time6:'year',
  },
  OffLineResult: {
    title1: 'Offline translation',
    title2: 'Audio/Video Call',
    title3: 'Basic Services',
    success: 'Subscription Success',
    fail:'Subscription failed',
    stock:'Exchange code in stock',
    saveTitle: 'Save the redemption code and go to the APP to redeem it',
    code: 'Redeem code',
    tip1: 'This code is only used to redeem the offline translation function',
    tip2: 'This code is only used to redeem audio/video call translation function',
    tip3: 'This code is only used for redeeming basic service renewal functions',
    save: "save",
    time:"Subscription time：",
    copy:"Copy",
    copySuccess:'Replicating Success',
    loading:'Loading...',
    paySuccess:'pay success'
  },
  RedemptionList:{
    title:"My redemption code",
    view:'Check',
    time: "Subscription time：",
  },
  MyRedemption: {
    title: 'My redemption code',
    code: 'redemption code',
    time: 'Subscription time：',
    copy: 'Copy',
    tip1: 'This code is only used to redeem the offline translation function',
    tip2: 'This code is only used to redeem audio/video call translation function',
    tip3: 'This code is only used for redeeming basic service renewal functions',
    save: 'save',
    success:"Operation successful"
  },
  basePage:{
    error1:'No product information obtained',
    message1:'Please select a product',
    title:'Basic Services',
    function:'Real-time voice translation, barrier-free communication',
    describe: 'Subscription Instructions',
    describe1:'1. After renewal, basic services such as simultaneous interpretation and conference assistant will be valid for the same period as the device. If the device is replaced, it needs to be renewed.',
    describe2:'2. Basic services cannot be refunded after renewal.',
    payType:'Payment Methods',
    card:'Card',
    wx:'WeChat',
    GooglePay:'Google Pay',
    subscribe:'Subscription',
    RMB: '¥',
    sale:'off',
    month:'month',
    confirm:'confirm',
    month1:'1 month',
    month2:'half a year',
    month3:'1 year'
  },
  ...enLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
export default en;
